import { KeyTake } from "@pdfking/tfunc"

import { is_null } from "./is_null"
import { to_array } from "./to_array"

export const key_take = (data, to_take) => {
  if (is_null(to_take)) return data
  return KeyTake(data, to_array(to_take))
}
